<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="mb-4 text-inherit">My Profile</h3>

        <div v-if="!isLoading">
          <h5 class="text-inherit">
            {{ user.first_name }} {{ user.last_name }}
          </h5>

          <table class="my-3">
            <tr>
              <td>Username</td>
              <td>{{ username }}</td>
            </tr>
            <tr>
              <td>Last Login</td>
              <td>{{ lastLogin }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ email }}</td>
            </tr>
            <tr>
              <td>Organisation</td>
              <td>
                <OrganisationAssigner
                  v-on:assigned="getAdditionalInfo"
                  :organisation-name="organisationName"
                />
              </td>
            </tr>
            <tr v-if="organisationCode">
              <td>Organisation Code</td>
              <td>
                {{ organisationCode }}
              </td>
            </tr>
            <tr v-if="registerLink">
              <td>Register Link</td>
              <td>
                {{ registerLink }}
                <button
                  class="btn btn-sm btn-primary"
                  @click="copyRegisterLink()"
                >
                  {{ copyBtnText }}
                </button>
              </td>
            </tr>
            <tr>
              <td>Website</td>
              <td>
                <a v-bind:href="user.organisationWebsite">
                  <em>{{ organisationWebsite || "-" }}</em>
                </a>
              </td>
            </tr>
            <tr>
              <td>Phone</td>
              <td>{{ mobilePhone || "-" }}</td>
            </tr>
          </table>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import UserService from "../services/user.service";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";
import OrganisationAssigner from "@/components/OrganisationAssigner";
import logger from "@/utils/logger";

export default {
  name: "MyDetailsChange",
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    registerLink() {
      return `${window.location.origin}/register/?orgcode=${this.organisationCode}`;
    },
  },
  components: {
    OrganisationAssigner,
    UserMenu,
    CommunityCard,
    Footer,
  },
  data: function () {
    return {
      isLoading: true,
      lastLogin: "",
      username: "",
      email: "",
      organisationName: "",
      organisationWebsite: "",
      mobilePhone: "",
      organisationCode: "",
      copyBtnText: "Copy",
    };
  },
  methods: {
    getAdditionalInfo() {
      this.isLoading = true;
      UserService.getUserDetails(this.user.uuid_id).then((data) => {
        this.username = data.username;
        this.lastLogin = data.last_login;
        this.email = data.email;
        this.organisationName = data.organisation ? data.organisation.name : "";
        this.organisationWebsite = data.organisation
          ? data.organisation.website
          : "";
        this.organisationCode = data.organisation
          ? data.organisation.organisation_code
          : "";
        this.mobilePhone = data.mobile_phone;
        this.isLoading = false;
      });
    },
    copyRegisterLink() {
      if (!document.queryCommandSupported("copy")) {
        if (navigator.clipboard && navigator.clipboard.write) {
          navigator.clipboard.write(this.registerLink);
        } else {
          logger.error("profile.copy_link.unsupported", "Browser doesn't support either copy method");
        }

        return;
      }

      const textArea = document.createElement("textarea");
      textArea.value = this.registerLink;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("Copy");
      textArea.remove();
      this.copyBtnText = "Copied!";

      setTimeout(() => {
        this.copyBtnText = "Copy";
      }, 5000);
    },
  },
  mounted() {
    this.isLoading = true;
    this.getAdditionalInfo();
  },
};
</script>

<style scoped>
table {
  font-size: 0.9rem;
  width: 100%;
}

td:first-child {
  width: 20%;
}

tr {
  border-bottom: 1px solid #f1f1f1;
  height: 40px;
}

tr:last-child {
  border-bottom: none;
}
</style>
